<template>
  <div
    class="maxMaxth home-scrollbar maxMaxth3Dian1"
    :style="{
      'background-image': `url(${config.background_image})`
    }"
  >
    <advertisementHome
      v-if="popList.length"
      @CancelDisplay="CancelDisplay"
      :popList="popList"
      :isShow="isCancelDisplay"
    ></advertisementHome>
    <div>
      <sidebars
        :sidebarsList="sidebarsList"
        :class="{ 'sidebar-hidden': sidebarHidden }"
      >
      </sidebars>
      <sidebarsLeft
        :sidebarsList="sidebarsLeftList"
        :class="{ 'sidebaLeft-hidden': sidebarHidden }"
      >
      </sidebarsLeft>
    </div>
    <Header></Header>
    <div
      class="conterTeng-scrollbar"
      ref="homeScrollbar"
      @scroll="handleScroll"
      :style="{
        height: `calc(100vh - ${$store.state.xiazApp ? 0.9 + 0.7 : 0.9}rem)`
      }"
    >
      <!-- <div class="gang_area">
				<div></div>
			</div> -->
      <van-grid
        v-if="topNavList && topNavList.length > 0"
        :border="false"
        :column-num="topNavList.length"
      >
        <van-grid-item
          v-for="(item, index) in topNavList"
          :key="index"
          @click="doJump(item)"
          style="cursor: pointer"
        >
          <van-image :src="item.img" />
          <div
            class="_marketing-title_1k0qx_129"
            :style="{
              'font-size': '.2rem',
              color: '#fff',
              'background-color': item.nameColor
            }"
          >
            <span>{{ item.name }}</span>
          </div>
        </van-grid-item>
      </van-grid>
      <!-- :offset-top="`${$store.state.xiazApp?.9+.7:.9}rem`" -->
      <div
        class="zhtDEqmqr6aOwFvu_UTp"
        v-if="
          $store.state.config.show_jackpot &&
          $store.state.config.jackpot_position == 'top'
        "
      >
        <div
          class="_VQdc8vOEOzzyOEUKmvZ"
          :style="`margin: 0.2rem 0 0.2rem;background-position: 0px 0px;background-image: url(${config.jackpot_image});background-size: 100% 100%;`"
        >
          <CountTo
            :startVal="startVal"
            @getDisplayValue="getDisplayValue"
            :endVal="BonusAmount"
            :decimals="2"
            :duration="5000"
          />
          <div
            slot="defaultValue"
            class="defaultValue"
            style="
              margin-top: 0.4rem;
              display: flex;
              align-items: center;
              --jackpot-card-count-box-scale: 0.6;
              transform: scale(var(--jackpot-card-count-box-scale));
            "
          >
            <span
              v-for="(char, index) in getBonusChars(BonusTrendsAmount)"
              :key="index"
              :class="`sprite-font sprite-char-${char}`"
              :style="getSpriteStyle(char)"
              style="display: inline-block; height: 0.83rem"
            >
            </span>
          </div>
        </div>
      </div>

      <div class="live-box" v-if="$store.state.config.show_home_ad">
        <div class="live-box-item" @click="openUrl('luckyTurntable')">
          <img :src="config.ui38.activity_1" alt="" />
        </div>
        <div class="live-box-item" @click="openUrl('LinkdeConviteEvent')">
          <img :src="config.ui38.activity_2" alt="" />
        </div>
        <div class="live-box-item" @click="openUrl('vip')">
          <img :src="config.ui38.activity_3" alt="" />
        </div>
      </div>
      <Swipe :swipeList="banner"></Swipe>
      <div
        v-if="$store.state.config.old_sites.length > 0"
        style="
          width: calc(100% - 0.4rem);
          margin: 0 0.2rem;
          white-space: nowrap;
          overflow-x: auto;
          overflow-y: hidden;
          cursor: grab;
          overscroll-behavior-x: contain;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          justify-content: space-around;
        "
      >
        <img
          v-for="val in $store.state.config.old_sites"
          draggable="false"
          :src="val.logo"
          @click="doJump({jump_url:val.url})"
          class="rawImg"
        />
      </div>
      <div
        class="zhtDEqmqr6aOwFvu_UTp"
        v-if="
          $store.state.config.show_jackpot &&
          $store.state.config.jackpot_position == 'up'
        "
      >
        <div
          class="_VQdc8vOEOzzyOEUKmvZ"
          :style="`margin: var(--jackpot-card-margin);background-position: 0px 0px;background-image: url(${config.jackpot_image});background-size: 100% 100%;`"
        >
          <CountTo
            :startVal="startVal"
            @getDisplayValue="getDisplayValue"
            :endVal="BonusAmount"
            :decimals="2"
            :duration="5000"
          />
          <div
            slot="defaultValue"
            class="defaultValue"
            style="
              margin-top: 0.4rem;
              display: flex;
              align-items: center;
              --jackpot-card-count-box-scale: 0.6;
              transform: scale(var(--jackpot-card-count-box-scale));
            "
          >
            <span
              v-for="(char, index) in getBonusChars(BonusTrendsAmount)"
              :key="index"
              :class="`sprite-font sprite-char-${char}`"
              :style="getSpriteStyle(char)"
              style="display: inline-block; height: 0.83rem"
            >
            </span>
          </div>
        </div>
      </div>

      <div class="notice-bar">
        <!-- notice -->
        <div
          style="
            position: relative;
            width: 0.32rem;
            height: 0.32rem;
            color: var(--theme-text-color);
            margin-right: 0.2rem;
          "
        >
          <svg-icon
            class="svg-icon_pmd mt2"
            style="font-size: 0.32rem"
            icon-class="icon_dt_2pmd--svgSprite:all"
          />
        </div>
        <van-notice-bar class="marquee" style="height: 20px" :scrollable="true">
          <div style="display: flex; align-items: center">
            <div
              v-for="(item, index) in marquee"
              @click="openUrl('notice', { active: 3, marqueeIndex: index })"
              v-html="item"
            ></div>
          </div>
        </van-notice-bar>
        <i
          :style="`margin-left:5px;display: inline-block; position: relative; width: 0.5rem; height: 0.4375rem; background-image: url(${_coloImg}); background-position: -5.3375rem -4.275rem; background-size: 9.075rem 8.85625rem;`"
        ></i>
      </div>
      <div
        class="zhtDEqmqr6aOwFvu_UTp"
        v-if="
          $store.state.config.show_jackpot &&
          $store.state.config.jackpot_position == 'up2'
        "
      >
        <div
          class="_VQdc8vOEOzzyOEUKmvZ"
          :style="`margin: 0.2rem 0 0.2rem;background-position: 0px 0px;background-image: url(${config.jackpot_image});background-size: 100% 100%;`"
        >
          <CountTo
            :startVal="startVal"
            @getDisplayValue="getDisplayValue"
            :endVal="BonusAmount"
            :decimals="2"
            :duration="5000"
          />
          <div
            slot="defaultValue"
            class="defaultValue"
            style="
              margin-top: 0.4rem;
              display: flex;
              align-items: center;
              --jackpot-card-count-box-scale: 0.6;
              transform: scale(var(--jackpot-card-count-box-scale));
            "
          >
            <span
              v-for="(char, index) in getBonusChars(BonusTrendsAmount)"
              :key="index"
              :class="`sprite-font sprite-char-${char}`"
              :style="getSpriteStyle(char)"
              style="display: inline-block; height: 0.83rem"
            >
            </span>
          </div>
        </div>
      </div>
      <GameSwiper v-if="$store.state.special_game.length > 0"></GameSwiper>
      <div
        class="tabs conter_box"
        :class="{
          isTabsShow: isTabsShow
        }"
        style="padding-bottom: 1rem"
      >
        <van-tabs
          v-model="$store.state.active"
          @change="tabFun"
          ref="navTbaSwConte"
          @disabled="onClickDisabled"
          scrollspy
          sticky
          :offset-top="`${
            $store.state.xiazApp ? 0.9 + 0.7 - 1.14 : 0.9 - 1.14
          }rem`"
          @scroll="scrollTabs"
        >
          <div slot="nav-left" class="tabForm-box">
            <div
              v-if="tabForm.leftRight != 0"
              @click.stop="navTbaSw('left')"
              tabkey="left"
              class="LLCEvsnIyNozmsBiz0sD leftButton"
            >
              <svg-icon icon-class="img_scroll_jt--svgSprite:all" />
            </div>
            <div
              v-if="tabForm.leftRight != 1"
              @click.stop="navTbaSw('right')"
              tabkey="right"
              class="xQxdPR5O2U8rhaYlHoeQ rightButton"
            >
              <svg-icon icon-class="img_scroll_jt--svgSprite:all" />
            </div>
          </div>
          <div
            class="zhtDEqmqr6aOwFvu_UTp"
            v-if="
              $store.state.config.show_jackpot &&
              $store.state.config.jackpot_position == 'down'
            "
          >
            <div
              class="_VQdc8vOEOzzyOEUKmvZ"
              :style="`margin: 0.2rem 0 0;background-position: 0px 0px;background-image: url(${config.jackpot_image});background-size: 100% 100%;`"
            >
              <CountTo
                :startVal="startVal"
                @getDisplayValue="getDisplayValue"
                :endVal="BonusAmount"
                :decimals="2"
                :duration="5000"
              />
              <div
                slot="defaultValue"
                class="defaultValue"
                style="
                  margin-top: 0.4rem;
                  display: flex;
                  align-items: center;
                  --jackpot-card-count-box-scale: 0.6;
                  transform: scale(var(--jackpot-card-count-box-scale));
                "
              >
                <span
                  v-for="(char, index) in getBonusChars(BonusTrendsAmount)"
                  :key="index"
                  :class="`sprite-font sprite-char-${char}`"
                  :style="getSpriteStyle(char)"
                  style="display: inline-block; height: 0.83rem"
                >
                </span>
              </div>
            </div>
          </div>
          <!-- <div slot="nav-left" class="">
						叔叔叔叔
					</div>
					<div slot="nav-right" class="">
						叔叔叔叔
					</div> -->
          <van-tab
            v-for="(item, index) in iconList"
            :key="index"
            :name="index"
            :disabled="item.textName == '_Demo'"
          >
            <div
              slot="title"
              class="h5MidMenuTab"
              style="color: none !important"
              v-if="
                item.textName &&
                !$store.state.config.category_hide.includes(item.textName)
              "
              :name="index"
            >
              <img class="imageWrap" :src="activeList[index]" alt="" />
              <div
                class="N4LsWhJBhqqyTkv6V0NE game-category-name"
                style="margin-bottom: -1.46824px; padding-bottom: 1.46824px"
              >
                {{ $t('popup.nav_31')[index].title }}
              </div>
            </div>

            <div
              class="vwuYKuCNAmUF0GsyJhVu"
              v-if="
                tabNav[item.name] &&
                stateActive &&
                !$store.state.config.category_hide.includes(item.textName)
              "
            >
              <div class="kQtvRRirB33JTKwlSb26 titleWrap">
                <div class="leftTitle">
                  <img
                    class="imageWrap"
                    style="margin-right: 0.07rem"
                    :src="activeList[index]"
                    alt=""
                  />
                  {{ $t('popup.nav_31')[index].title }}
                </div>
                <div
                  class="rightTitle"
                  v-if="$t('popup.nav_31')[index].title != 'Popular'"
                  @click="subgame(item.name)"
                >
                  Tudo
                </div>
              </div>
              <div class="gameItemBox">
                <gameItem
                  v-for="(item_a, index_1) in tabNav[item.name].list"
                  :category="item.name"
                  :item="item_a"
                  type="home"
                  :key="index_1"
                ></gameItem>
                <div
                  style="display: flex; justify-content: center; width: 100%"
                >
                  <van-empty
                    v-if="!tabNav[item.name].list.length"
                    image-size="106px"
                    class="custom-image"
                    :image="img_none_sj"
                    :description="$t('_Nenhumjogodisponvel')"
                  />
                </div>
              </div>
              <div
                class="bkAYznjEc9hUqGQh_a3S scroll-down"
                @click="congxJiazai(item.name)"
                v-if="tabNav[item.name].now < tabNav[item.name].count"
              >
                {{ $t('_home._Aexibir') }} {{ tabNav[item.name].now }}
                {{ $t('_home._jogosentre') }}
                {{ tabNav[item.name].count }}&nbsp;{{
                  $t('popup')[item.textName]
                }}{{ $t('_home._Popularjogos') }}
                <div class="WGAruokZzpTWkHI2SQ9G scroll-text cursor-pointer">
                  {{ $t('_home._Carregarmais') }}
                  <svg-icon
                    className="imageWrap_s"
                    style="
                      width: 0.14rem;
                      height: 0.14rem;
                      vertical-align: unset;
                    "
                    icon-class="comm_icon_jzgd--svgSprite:all"
                  />
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>

        <div
          class="vwuYKuCNAmUF0GsyJhVu"
          v-if="iconList[$store.state.active].textName == '_Recente'"
        >
          <div class="kQtvRRirB33JTKwlSb26 titleWrap">
            <div class="leftTitle">
              <img
                class="imageWrap"
                style="margin-right: 0.07rem"
                :src="activeList[$store.state.active]"
                alt=""
              />
              {{ $t('popup')[iconList[$store.state.active].textName] }}
            </div>
          </div>
          <div class="gameItemBox" v-if="favoriteJson.list">
            <gameItem
              v-for="(item_a, index_1) in recentJson.list"
              :item="item_a"
              type="home"
              :key="index_1"
            ></gameItem>
            <div style="display: flex; justify-content: center; width: 100%">
              <van-empty
                v-if="!recentJson.list.length"
                image-size="106px"
                class="custom-image"
                :image="img_none_sj"
                :description="$t('_Nenhumjogodisponvel')"
              />
            </div>
          </div>
          <div
            class="bkAYznjEc9hUqGQh_a3S scroll-down"
            @click="congxJiazai(iconList[$store.state.active].name)"
            v-if="recentJson.now < recentJson.count"
          >
            {{ $t('_home._Aexibir') }} {{ recentJson.now }}
            {{ $t('_home._jogosentre') }} {{ recentJson.count }}&nbsp;{{
              $t('_home._Popularjogos')
            }}
            <div class="WGAruokZzpTWkHI2SQ9G scroll-text cursor-pointer">
              {{ $t('_home._Carregarmais') }}
              <svg-icon
                className="imageWrap_s"
                style="width: 0.14rem; height: 0.14rem; vertical-align: unset"
                icon-class="comm_icon_jzgd--svgSprite:all"
              />
            </div>
          </div>
        </div>
        <div
          class="vwuYKuCNAmUF0GsyJhVu"
          v-if="iconList[$store.state.active].textName == '_Favoritos'"
        >
          <div class="kQtvRRirB33JTKwlSb26 titleWrap">
            <div class="leftTitle">
              <img
                class="imageWrap"
                style="margin-right: 0.07rem"
                :src="activeList[$store.state.active]"
                alt=""
              />
              {{ $t('popup')[iconList[$store.state.active].textName] }}
            </div>
          </div>
          <div class="gameItemBox" v-if="favoriteJson.list">
            <gameItem
              v-for="(item_a, index_1) in favoriteJson.list"
              :item="item_a"
              type="home"
              :key="index_1"
            >
            </gameItem>
            <div style="display: flex; justify-content: center; width: 100%">
              <van-empty
                v-if="!favoriteJson.list.length"
                image-size="106px"
                class="custom-image"
                :image="img_none_sj"
                :description="$t('_Nenhumjogodisponvel')"
              />
            </div>
          </div>
          <div
            class="bkAYznjEc9hUqGQh_a3S scroll-down"
            @click="congxJiazai(iconList[$store.state.active].name)"
            v-if="favoriteJson.now < favoriteJson.count"
          >
            {{ $t('_home._Aexibir') }} {{ favoriteJson.now }}
            {{ $t('_home._jogosentre') }} {{ favoriteJson.count }}&nbsp;{{
              $t('_home._Popularjogos')
            }}
            <div class="WGAruokZzpTWkHI2SQ9G scroll-text cursor-pointer">
              {{ $t('_home._Carregarmais') }}
              <svg-icon
                className="imageWrap_s"
                style="width: 0.14rem; height: 0.14rem; vertical-align: unset"
                icon-class="comm_icon_jzgd--svgSprite:all"
              />
            </div>
          </div>
        </div>

        <div class="LseXQWJMvDiV2XalL3sA">
          <div class="bUGFPYZ0IBtUg6TvqFnc vertival-box">
            <div class="UJY0E549iXw8BAops2og item-box">
              <div class="JxE2bCrlce_jVHNQ56UL link-list-title">
                {{ $t('_home._Cassino') }}
              </div>
              <div class="dIvaBEC9yHdlaEHxlYwe">
                <div
                  @click="openUrl('event')"
                  class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                >
                  {{ $t('_home._Eventos') }}
                </div>
                <div
                  class="m4LhLKEZzJw_JjBFp0PP link-list-item ImbZfuNlIcC1JuS98DxH"
                >
                  {{ $t('_home._Missão') }}
                </div>
                <div
                  class="m4LhLKEZzJw_JjBFp0PP link-list-item ImbZfuNlIcC1JuS98DxH"
                >
                  {{ $t('_home._Rebate') }}
                </div>
                <div
                  @click="openUrl('canReceive')"
                  class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                >
                  {{ $t('_home._Pendente') }}
                </div>
                <div
                  @click="openUrl('vip')"
                  class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                >
                  {{ $t('_home._VIP') }}
                </div>
                <div
                  @click="openUrl('promote')"
                  class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                >
                  {{ $t('_home._Convidar') }}
                </div>
                <div
                  @click="openUrl('rechargeFund')"
                  class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                >
                  {{ $t('_home._FundodePrevidência') }}
                </div>
                <div class="m4LhLKEZzJw_JjBFp0PP link-list-item">
                  {{ $t('_home._Surpresa') }}
                </div>
                <!--  -->
              </div>
            </div>
            <!--
				'_Cassino:"Cassino",_Jogos:"Jogos",_Suporte:"Suporte",
				 -->
            <div class="UJY0E549iXw8BAops2og item-box">
              <div class="JxE2bCrlce_jVHNQ56UL link-list-title">
                {{ $t('_home._Jogos') }}
              </div>
              <div class="dIvaBEC9yHdlaEHxlYwe">
                <div
                  v-if="!$store.state.config.category_hide.includes('_Slots')"
                  @click="subgame('slots')"
                  class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                >
                  {{ $t('_home._Slots') }}
                </div>
                <div
                  v-if="
                    !$store.state.config.category_hide.includes('_Blockchain')
                  "
                  @click="subgame('blockchain')"
                  class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                >
                  {{ $t('_home._Blockchain') }}
                </div>
                <div
                  v-if="
                    !$store.state.config.category_hide.includes('_Pescaria')
                  "
                  @click="subgame('piscator')"
                  class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                >
                  {{ $t('_home._Pescaria') }}
                </div>
                <div
                  v-if="
                    !vuex_tokenIs &&
                    !$store.state.config.category_hide.includes('_Demo')
                  "
                  class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                >
                  {{ $t('_home._Demo') }}
                </div>
              </div>
            </div>
            <div class="UJY0E549iXw8BAops2og item-box">
              <div class="JxE2bCrlce_jVHNQ56UL link-list-title">
                {{ $t('_home._Suporte') }}
              </div>
              <div class="dIvaBEC9yHdlaEHxlYwe">
                <div
                  @click="openUrl('notice')"
                  class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                >
                  {{ $t('_home._Suporteonline') }}
                </div>
                <div
                  @click="openUrl('notice')"
                  class="m4LhLKEZzJw_JjBFp0PP link-list-item"
                >
                  {{ $t('_home._CentraldeAjuda') }}
                </div>
                <!-- <div @click="openUrl('notice')" class="m4LhLKEZzJw_JjBFp0PP link-list-item">{{ $t('_home._BônusdeSugestão') }}</div> -->
              </div>
            </div>
          </div>

          <div
            v-if="$store.state.config.bottom_img_type != 'fb'"
            class="ant-spin-nested-loading URYVffVETVSIkPGB9P5E custom-loading__wrap contactus-box mmensnemConem"
          >
            <div class="ant-spin-container">
              <div
                class="dX6cyFScnFIBaOgvBaOs contact-us-title"
                style="margin-top: 0.2rem; margin-bottom: 0.3rem"
              >
                {{ $t('_home._LicenseCompliance') }}
              </div>
              <div class="license-compliance">
                <img
                  src="./../../assets/kuaijiexiaz/18plus.webp"
                  style="width: 0.9rem; height: 0.9rem"
                />
              </div>
            </div>
          </div>

          <!-- w1风格 -->
          <div
            v-if="['', 'w1'].includes($store.state.config.bottom_img_type)"
            class="ant-spin-nested-loading URYVffVETVSIkPGB9P5E custom-loading__wrap contactus-box mmensnemConem"
          >
            <div class="ant-spin-container">
              <div class="dX6cyFScnFIBaOgvBaOs contact-us-title">
                {{ $t('_home._Contatenos') }}
              </div>
              <div class="M5NoRqtHOQuocfpNLEaP contact-us">
                <div
                  class="ZRKW0CIFYaJACLzrm8Rh"
                  @click="goToNewPage($store.state.config.instagram)"
                >
                  <img
                    src="./../../assets/kuaijiexiaz/instagram.png"
                    style="width: 0.7rem; height: 0.7rem"
                  />
                </div>
                <div
                  class="ZRKW0CIFYaJACLzrm8Rh"
                  @click="goToNewPage($store.state.config.telegram)"
                >
                  <img
                    src="./../../assets/kuaijiexiaz/img_tg.png"
                    style="width: 0.7rem; height: 0.7rem"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="$store.state.config.bottom_img_type == 'w1'"
            class="ant-spin-nested-loading URYVffVETVSIkPGB9P5E custom-loading__wrap contactus-box mmensnemConem"
          >
            <div class="ant-spin-container">
              <div class="dX6cyFScnFIBaOgvBaOs contact-us-title">
                {{ $t('_home._CanalOficial') }}
              </div>
              <div class="M5NoRqtHOQuocfpNLEaP contact-us">
                <div
                  v-if="$store.state.config.cnpj_link != '@'"
                  class="ZRKW0CIFYaJACLzrm8Rh"
                  @click="goToNewPage($store.state.config.cnpj_link)"
                >
                  <img
                    src="./../../assets/kuaijiexiaz/cnpj.png"
                    style="width: 0.7rem; height: 0.7rem"
                  />
                </div>
                <div
                  class="ZRKW0CIFYaJACLzrm8Rh"
                  @click="goToNewPage($store.state.config.instagram)"
                >
                  <img
                    src="./../../assets/kuaijiexiaz/instagram.png"
                    style="width: 0.7rem; height: 0.7rem"
                  />
                </div>
                <div
                  class="ZRKW0CIFYaJACLzrm8Rh"
                  @click="goToNewPage($store.state.config.whatsapp)"
                >
                  <img
                    src="./../../assets/kuaijiexiaz/img_wa.png"
                    style="width: 0.7rem; height: 0.7rem"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- u44风格 -->
          <div
            v-if="$store.state.config.bottom_img_type == 'u44'"
            class="ant-spin-nested-loading URYVffVETVSIkPGB9P5E custom-loading__wrap contactus-box mmensnemConem"
          >
            <div class="ant-spin-container">
              <div class="dX6cyFScnFIBaOgvBaOs contact-us-title">
                {{ $t('_home._CanalOficial') }}
              </div>
              <div class="M5NoRqtHOQuocfpNLEaP contact-us">
                <div
                  v-if="$store.state.config.cnpj_link != '@'"
                  class="ZRKW0CIFYaJACLzrm8Rh"
                  @click="goToNewPage($store.state.config.cnpj_link)"
                >
                  <img
                    src="./../../assets/kuaijiexiaz/cnpj.png"
                    style="width: 0.7rem; height: 0.7rem"
                  />
                </div>
                <div
                  class="ZRKW0CIFYaJACLzrm8Rh"
                  @click="goToNewPage($store.state.config.telegram)"
                >
                  <img
                    src="./../../assets/kuaijiexiaz/telegram.png"
                    style="width: 0.7rem; height: 0.7rem"
                  />
                </div>
                <div
                  class="ZRKW0CIFYaJACLzrm8Rh"
                  @click="goToNewPage($store.state.config.whatsapp)"
                >
                  <img
                    src="./../../assets/kuaijiexiaz/img_wa.png"
                    style="width: 0.7rem; height: 0.7rem"
                  />
                </div>
                <div
                  class="ZRKW0CIFYaJACLzrm8Rh"
                  @click="goToNewPage($store.state.config.facebook)"
                >
                  <img
                    src="./../../assets/kuaijiexiaz/Facebook.png"
                    style="width: 0.7rem; height: 0.7rem"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- fb风格 -->
          <div v-if="$store.state.config.bottom_img_type == 'fb'">
            <div
              class="ant-spin-nested-loading URYVffVETVSIkPGB9P5E custom-loading__wrap contactus-box mmensnemConem"
            ></div>
            <div
              class="ant-spin-nested-loading URYVffVETVSIkPGB9P5E custom-loading__wrap contactus-box mmensnemConem"
            >
              <div
                class="ant-spin-container"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div class="M5NoRqtHOQuocfpNLEaP contact-us">
                  <div
                    v-if="$store.state.config.cnpj_link != '@'"
                    class="ZRKW0CIFYaJACLzrm8Rh"
                    @click="goToNewPage($store.state.config.cnpj_link)"
                  >
                    <img
                      src="./../../assets/kuaijiexiaz/cnpj.png"
                      style="width: 0.7rem; height: 0.7rem"
                    />
                  </div>
                  <div class="ZRKW0CIFYaJACLzrm8Rh">
                    <img
                      src="./../../assets/kuaijiexiaz/fb/twitter.png"
                      style="width: 0.7rem; height: 0.7rem"
                    />
                  </div>
                  <div class="ZRKW0CIFYaJACLzrm8Rh">
                    <img
                      src="./../../assets/kuaijiexiaz/fb/tk.png"
                      style="width: 0.7rem; height: 0.7rem"
                    />
                  </div>
                  <div
                    class="ZRKW0CIFYaJACLzrm8Rh"
                    @click="goToNewPage($store.state.config.facebook)"
                  >
                    <img
                      src="./../../assets/kuaijiexiaz/fb/fb.png"
                      style="width: 0.7rem; height: 0.7rem"
                    />
                  </div>
                  <div
                    class="ZRKW0CIFYaJACLzrm8Rh"
                    @click="goToNewPage($store.state.config.instagram)"
                  >
                    <img
                      src="./../../assets/kuaijiexiaz/fb/ins.png"
                      style="width: 0.7rem; height: 0.7rem"
                    />
                  </div>
                  <div class="ZRKW0CIFYaJACLzrm8Rh">
                    <img
                      src="./../../assets/kuaijiexiaz/18plus.webp"
                      style="width: 0.7rem; height: 0.7rem"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="TNhhMltbvlGJmWgLd9F5 logo-area">
              <img
                src="./../../assets/kuaijiexiaz/fb/pg.png"
                class="goDRiiBsuEuXD3W1NphN"
                style="height: 0.38rem"
              />
              <img
                src="./../../assets/kuaijiexiaz/fb/pp.png"
                class="goDRiiBsuEuXD3W1NphN"
                style="height: 0.38rem"
              />
              <img
                src="./../../assets/kuaijiexiaz/fb/jdb.png"
                class="goDRiiBsuEuXD3W1NphN"
                style="height: 0.38rem"
              />
              <img
                src="./../../assets/kuaijiexiaz/fb/mg.png"
                class="goDRiiBsuEuXD3W1NphN"
                style="height: 0.38rem"
              />
              <img
                src="./../../assets/kuaijiexiaz/fb/tada.png"
                class="goDRiiBsuEuXD3W1NphN"
                style="height: 0.38rem"
              />
              <img
                src="./../../assets/kuaijiexiaz/fb/gc.png"
                class="goDRiiBsuEuXD3W1NphN"
                style="height: 0.38rem"
              />
              <img
                src="./../../assets/kuaijiexiaz/fb/pa.png"
                class="goDRiiBsuEuXD3W1NphN"
                style="height: 0.38rem"
              />
              <img
                src="./../../assets/kuaijiexiaz/fb/mga.png"
                class="goDRiiBsuEuXD3W1NphN"
                style="height: 0.38rem"
              />
            </div>
            <div
              class="ant-spin-nested-loading URYVffVETVSIkPGB9P5E custom-loading__wrap contactus-box mmensnemConem"
            ></div>
          </div>

          <!--  -->
          <div class="company-info">
            <p v-html="$store.state.config.explain_description"></p>
          </div>
          <!--  -->
          <div
            v-if="$store.state.config.bottom_img_type == 'w1'"
            style="text-align: center"
          >
            <img
              src="./../../assets/kuaijiexiaz/link_wg.png"
              style="max-width: 100%; width: 3rem"
            />
            <img
              src="./../../assets/kuaijiexiaz/link_tada.png"
              style="max-width: 100%; width: 3rem"
            />
            <img
              src="./../../assets/kuaijiexiaz/link_jdb.png"
              style="max-width: 100%; width: 3rem"
            />
            <img
              src="./../../assets/kuaijiexiaz/link_fc.png"
              style="max-width: 100%; width: 3rem"
            />
            <img
              src="./../../assets/kuaijiexiaz/link_cq9.png"
              style="max-width: 100%; width: 3rem"
            />
            <img
              src="./../../assets/kuaijiexiaz/link_joker.png"
              style="max-width: 100%; width: 3rem"
            />
            <img
              src="./../../assets/kuaijiexiaz/link_pp.png"
              style="max-width: 100%; width: 3rem"
            />
            <img
              src="./../../assets/kuaijiexiaz/link_pg.png"
              style="max-width: 100%; width: 3rem"
            />
          </div>
          <div
            v-if="$store.state.config.bottom_img_type == 'u44'"
            class="TNhhMltbvlGJmWgLd9F5 logo-area"
            style="padding-bottom: 0.5rem"
          >
            <img
              src="./../../assets/kuaijiexiaz/u44/pg.png"
              class="goDRiiBsuEuXD3W1NphN"
              style="height: 0.38rem"
            />
            <img
              src="./../../assets/kuaijiexiaz/u44/jili.png"
              class="goDRiiBsuEuXD3W1NphN"
              style="height: 0.38rem"
            />
            <img
              src="./../../assets/kuaijiexiaz/u44/jdb.png"
              class="goDRiiBsuEuXD3W1NphN"
              style="height: 0.38rem"
            />
            <img
              src="./../../assets/kuaijiexiaz/u44/pp.png"
              class="goDRiiBsuEuXD3W1NphN"
              style="height: 0.38rem"
            />
            <img
              src="./../../assets/kuaijiexiaz/u44/wg.png"
              class="goDRiiBsuEuXD3W1NphN"
              style="height: 0.38rem"
            />
            <img
              src="./../../assets/kuaijiexiaz/u44/cq9.png"
              class="goDRiiBsuEuXD3W1NphN"
              style="height: 0.38rem"
            />
            <img
              src="./../../assets/kuaijiexiaz/u44/pix.png"
              class="goDRiiBsuEuXD3W1NphN"
              style="height: 0.38rem"
            />
            <img
              src="./../../assets/kuaijiexiaz/u44/over.png"
              class="goDRiiBsuEuXD3W1NphN"
              style="height: 0.38rem"
            />
            <img
              src="./../../assets/kuaijiexiaz/u44/gc.png"
              class="goDRiiBsuEuXD3W1NphN"
              style="height: 0.38rem"
            />
            <img
              src="./../../assets/kuaijiexiaz/u44/mga.png"
              class="goDRiiBsuEuXD3W1NphN"
              style="height: 0.38rem"
            />
          </div>
          <!--  -->
          <div
            v-if="['u44', 'fb'].includes($store.state.config.bottom_img_type)"
            class="ZvyDsn48oSuCoga63jmJ copy-right"
          >
            <div
              class="ZvyDsn48oSuCoga63jmJ"
              style="
                padding-bottom: 0.1rem;
                font-size: 0.18rem;
                text-align: center;
              "
            >
              <ul>
                <li style="width: 50%">
                  <p
                    style="font-size: 0.18rem"
                    v-html="
                      $store.state.config.project_name +
                      $store.state.config.copyright
                    "
                  ></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!--  -->
      </div>

      <Sidebar></Sidebar>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from '@/components/sidebar/index.vue';
import Swipe from '@/components/swipe/index.vue';
import {
  ICON_NAV,
  ICON_NAVActive,
  ICON_NAV3Dian1,
  ICON_NAVActiveDian1
} from '@/assets/public/icon_nav.js';
import Overlay from '@/components/audio/overlay.vue';
import gameItem from '@/components/gameItem/index.vue';
import CountTo from '@/components/vue-count-to/vue-countTo.vue';
import advertisementHome from '@/components/advertisement/home.vue';
import sidebars from '@/components/sidebars/index.vue';
import sidebarsLeft from '@/components/sidebars/index-left.vue';
import { mapState } from 'vuex';
let time;
import Vue from 'vue';
import {
  baseConfig,
  popAndBanner,
  notification,
  jackpot,
  getAllGameCategory,
  getDataByGameCategory
} from '@/apis/modules/home.js';
import GameSwiper from '../game-swiper.vue';
export default {
  name: 'Home',
  components: {
    Sidebar,
    sidebarsLeft,
    Swipe,
    Overlay,
    sidebars,
    CountTo,
    gameItem,
    advertisementHome,
    GameSwiper
  },
  computed: {
    ...mapState([
      'first_recharge',
      'popList',
      'tabNav',
      'banner',
      'sidebarsList',
      'sidebarsLeftList',
      'marquee',
      'config',
      'isCancelDisplay',
      'vuex_token_head'
    ])
  },
  data() {
    return {
      tongzhi: require('./../../assets/icons/images/icon_dt_pmd.png'),
      coloImgactivity: require('./../../assets/icons/images/1795312712372871170.gif'),
      startVal: 0,
      iconList: [],
      stateActive: true,
      widUrl: window.location.href,
      activeList: ICON_NAVActiveDian1,
      base_Config: {},
      BonusAmount: '',
      BonusTrendsAmount: '',
      recentJson: {},
      favoriteJson: {},
      thisiTime: '',
      tabState: false,
      vuex_tokenIs: false,
      scrollDom: '',
      isTabsShow: false,
      tabForm: {
        leftRight: 0
      },
      topNavList: this.$store.state.config.top_nav_list,
      // 精灵图字符映射
      spriteCharMap: {
        0: { x: 0, y: 0, width: 0.5 },
        1: { x: -0.5, y: 0, width: 0.5 },
        2: { x: -1.05, y: 0, width: 0.5 },
        3: { x: -1.52, y: 0, width: 0.5 },
        4: { x: -2.05, y: 0, width: 0.5 },
        5: { x: -2.55, y: 0, width: 0.5 },
        6: { x: -3.05, y: 0, width: 0.5 },
        7: { x: -3.55, y: 0, width: 0.5 },
        8: { x: -4.08, y: 0, width: 0.5 },
        9: { x: -4.55, y: 0, width: 0.5 },
        '.': { x: -5.05, y: 0, width: 0.3 },
        ',': { x: -5.35, y: 0, width: 0.3 }
      },
      // Sidebar滚动隐藏相关状态
      sidebarHidden: false,
      scrollTimer: null,
      lastScrollTime: 0,
    };
  },
  created() {
    this.inviteFun();

    // 添加集团信息
    if (this.$store.state.config.group_info && !ICON_NAV3Dian1[7]) {
      ICON_NAV3Dian1.push({
        name: this.$store.state.config.group_info.name,
        svg: '',
        textName: this.$store.state.config.group_info.name
      });
      ICON_NAVActiveDian1.push(this.$store.state.config.group_info.icon);
      this.$t('popup.nav_31').push({
        title: this.$store.state.config.group_info.name,
        type: 'gorup'
      });
    }

    // 鱼在前面
    if (
      this.$store.state.config.fish_first &&
      ICON_NAV3Dian1[2].name != 'piscator'
    ) {
      [ICON_NAV3Dian1[2], ICON_NAV3Dian1[3]] = [
        ICON_NAV3Dian1[3],
        ICON_NAV3Dian1[2]
      ];
      [ICON_NAVActiveDian1[2], ICON_NAVActiveDian1[3]] = [
        ICON_NAVActiveDian1[3],
        ICON_NAVActiveDian1[2]
      ];
      [this.$t('popup.nav_31')[2], this.$t('popup.nav_31')[3]] = [
        this.$t('popup.nav_31')[3],
        this.$t('popup.nav_31')[2]
      ];
    }

    if (this._vuex_token && typeof this._vuex_token() == 'string') {
      this.getBalance();
      this.vuex_tokenIs = true;
      let demoIndex = 0;
      this.iconList = ICON_NAV3Dian1.filter((item, index) => {
        if (item.textName == '_Demo') demoIndex = index;
        return item.textName != '_Demo';
      });
      this.activeList = ICON_NAVActiveDian1.filter((item, index) => {
        return index != demoIndex;
      });
      if (this.$t('popup.nav_31')[demoIndex].title == 'Demo') {
        this.$t('popup.nav_31').splice(demoIndex, 1);
      }
    } else {
      this.iconList = ICON_NAV3Dian1;
    }
    this.getpopAndBanner();
    this.getNotification();
    this.getAllGameCategory();
    this.showRegisterPage();
  },
  mounted() {
    Vue.prototype.homeScrollbarDom = this.$refs.homeScrollbar;
    this.$nextTick(() => {
      let el = this.$refs.navTbaSwConte.$el;
      let scrollDom = el.getElementsByClassName('van-tabs__nav')[0];
      this.scrollDom = scrollDom;
      let offsetWidth = scrollDom.offsetWidth;
      let scrollWidth = scrollDom.scrollWidth;
      let scrollJisuan = scrollWidth - offsetWidth;
      let { leftRight } = this.tabForm;
      scrollDom.addEventListener('scroll', e => {
        if (scrollJisuan <= scrollDom.scrollLeft) {
          this.tabForm.leftRight = 1;
        } else if (scrollDom.scrollLeft == 0) {
          this.tabForm.leftRight = 0;
        } else if (leftRight != 2 && scrollDom.scrollLeft != 0) {
          this.tabForm.leftRight = 2;
        }
      });
    });
    this.getjackpot(0);
  },
  beforeDestroy() {
    clearTimeout(this.thisiTime);
  },
  methods: {
    openUrl(e, a) {
      // 需要先登录
      if (
        ['luckyTurntable', 'LinkdeConviteEvent', 'vip'].includes(e) &&
        !this.vuex_token_head
      ) {
        let rememberPassword = window.localStorage.getItem('rememberPassword');
        if (rememberPassword && rememberPassword.length) {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 1]);
        } else {
          this.$store.commit('isRecord');
          this.$store.commit('publicFun', ['isRecordType', 0]);
        }
        return false;
      }
      if (a) {
        this.$router.push({
          name: e,
          query: {
            ...a
          }
        });
      } else {
        this.$router.push({ name: e });
      }
    },
    doJump(item) {
      if (item.jump_url && item.jump_url != '#') {
        if (/^http/.test(item.jump_url)) {
          console.log('chuji')
          window.open(item.jump_url, '_blank');
          return false;
        }
        if (item.jump_url == '#register') {
          if (!this.vuex_token_head) {
            let rememberPassword =
              window.localStorage.getItem('rememberPassword');
            if (rememberPassword && rememberPassword.length) {
              this.$store.commit('isRecord');
              this.$store.commit('publicFun', ['isRecordType', 1]);
            } else {
              this.$store.commit('isRecord');
              this.$store.commit('publicFun', ['isRecordType', 0]);
            }
            return false;
          }
          return false;
        }
        this.$router.push({ name: item.jump_url });
      }
    },
    // 精灵图字体相关方法
    getBonusChars(amount) {
      // 将数字转换为字符数组
      return String(amount || '0').split('');
    },
    getSpriteStyle(char) {
      const pos = this.spriteCharMap[char];
      if (pos) {
        return {
          backgroundPosition: `${pos.x}rem ${pos.y}rem`,
          width: `${pos.width}rem`,
          backgroundImage: `url(${require('../../assets/cjc1_style_' +
            this.$store.state.config.jackpot_number_img +
            '_font_sprite.webp')})`,
          backgroundSize: 'auto 100%',
          backgroundRepeat: 'no-repeat'
        };
      }
      return {
        backgroundImage: `url(${require('../../assets/cjc1_style_6_font_sprite.webp')})`,
        backgroundSize: 'auto 100%',
        backgroundRepeat: 'no-repeat',
        width: '0.5rem'
      };
    },
    subgame(name) {
      //console.log(name);
      if (name == 'slots') {
        name = 'slot';
      }
      this.$router.push({
        name: 'subgame',
        query: {
          category: name,
          platformValue: 'popular'
        }
      });
      // piscator
    },
    CancelDisplay(e) {
      this.$store.commit('publicFun', ['isCancelDisplay', false]);
      if (this.$store.state.isRefreshLoading) {
        setTimeout(() => {
          let isRechargeGiftTime = localStorage.getItem('isRechargeGiftTime');
          let isRechargeGift = localStorage.getItem('isRechargeGift');
          if (isRechargeGiftTime && isRechargeGift !== 'false') {
            if (isRechargeGiftTime < new Date().getTime()) {
              this.$store.commit('publicFun', ['isCancelDisplay', true]);
            }
          }
          if (!isRechargeGift && !isRechargeGiftTime) {
            if (this.first_recharge.status == 'show') {
              this.$store.commit('publicFun', ['isRechargeGift', true]);
            }
          }
        }, 500);
        this.$store.commit('publicFun', ['isRefreshLoading', false]);
      }
    },
    showRegisterPage() {
      if (this.vuex_tokenIs || !this.$store.state.config.register_page_pop)
        return;
      this.$store.commit('isRecord');
      this.$store.commit('publicFun', ['isRecordType', 0]);
    },
    inviteFun() {
      let { id, type } = this.$route.query;
      //console.log(this.$route.query,id,type,'inviteID 22')
      if (id) {
        window.localStorage.setItem('inviteID', id);
      }
      // this.$store.commit('isRecord')
      // this.$store.commit('publicFun',['isRecordType',0])
    },
    navTbaSw(e) {
      if (e == 'right') {
        this.scrollDom.scrollLeft = 1000;
      }
      if (e == 'left') {
        this.scrollDom.scrollLeft = 0;
      }
    },
    beforeChange(name, title) {
      //
    },
    scrollTabs(e) {},
    handleScroll(e) {
      // 记录当前滚动时间
      this.lastScrollTime = Date.now();

      // 滚动时隐藏Sidebar
      if (!this.sidebarHidden) {
        this.sidebarHidden = true;
      }

      // 清除之前的定时器
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
      }

      // 设置新的定时器，2秒后显示Sidebar
      this.scrollTimer = setTimeout(() => {
        this.sidebarHidden = false;
      }, 1500);

      clearTimeout(time);
      time = setTimeout(() => {
        clearTimeout(time);
        if (e.target.scrollTop > e.target.offsetHeight / 3 + 59) {
          this.$store.commit('publicFun', ['Returntotop', true]);
        } else if (this.$store.state.Returntotop) {
          this.$store.commit('publicFun', ['Returntotop', false]);
        }
        if (
          e.target.scrollTop >
          e.target.scrollHeight - e.target.offsetHeight - 20
        ) {
          this.isTabsShow = true;
        } else {
          this.isTabsShow = false;
        }
      }, 10);
    },
    isDisabled(index) {
      let isTrue = false;
      let active = this.$store.state.active;
      if (index == 3) {
        isTrue = true;
        return true;
      }
      if (active < 3) {
        if (index < 3) {
          return false;
        }
        if (index > 3) {
          isTrue = false;
          return true;
        }
      }
      if (active > 3) {
        if (index < 3) {
          isTrue = true;
          return true;
        }
        if (index > 3) {
          isTrue = false;
          return false;
        }
      }
      return isTrue;
    },
    getAllGameCategory() {
      if (this.tabNav.popular) {
        return false;
      }
      getAllGameCategory({}).then(({ code, data = {}, msg }) => {
        this.$store.commit('publicFun', ['tabNav', data]);
        this.$store.state.special_game = data.special_game;
      });
    },
    goToNewPage(url) {
      if (url == '#') {
        return false;
      }
      window.open(url, '_blank');
    },
    congxJiazai(category, _key_) {
      let pageSize =
        category == 'popular' && this.$store.state.config.popular_page_size
          ? this.$store.state.config.popular_page_size
          : 6;
      let page = this.tabNav[category]
        ? this.tabNav[category].now / pageSize + 1
        : 1;
      //console.log(_key_)
      if (_key_) {
        page = this[_key_ + 'Json'].now
          ? this[_key_ + 'Json'].now / pageSize + 1
          : 1;
      }
      getDataByGameCategory({
        category: category,
        page: page
      }).then(({ code, data = {}, msg }) => {
        if (!_key_) {
          this.tabNav[category] = {
            ...this.tabNav[category],
            now: data.now,
            list: [...this.tabNav[category].list, ...data.list]
          };
          this.$store.commit('publicFun', ['tabNav', this.tabNav]);
        } else {
          let listz = this[_key_ + 'Json'].list
            ? [...this[_key_ + 'Json'].list, ...data.list]
            : [...data.list];
          this[_key_ + 'Json'] = {
            ...this[_key_ + 'Json'],
            now: data.now,
            list: listz
          };
        }
      });
    },
    getDisplayValue(value) {
      this.BonusTrendsAmount = value;
    },
    getpopAndBanner() {
      //
      if (this.banner.length) {
        return false;
      }
      popAndBanner({}).then(({ code, data = {}, msg }) => {
        let { banner, pop, sidebars, first_recharge } = data;
        this.$store.commit('publicFun', ['banner', banner]);
        this.$store.commit('publicFun', ['first_recharge', first_recharge]);
        // this.banner = banner;
        if (!this.popList.length) {
          this.$store.commit(
            'popList',
            pop.map(item => {
              return {
                ...item,
                isShow: true
              };
            })
          );
        }
        this.$store.commit('publicFun', [
          'sidebarsList',
          sidebars.right.map(item => {
            return { ...item, isShow: true };
          })
        ]);
        this.$store.commit('publicFun', [
          'sidebarsLeftList',
          sidebars.left.map(item => {
            return { ...item, isShow: true };
          })
        ]);
      });
    },

    getNotification() {
      if (this.marquee) {
        return false;
      }
      notification({}).then(({ code, data, msg }) => {
        //404
        let { marquee } = data;
        this.$store.commit('publicFun', ['marquee', marquee]);
      });
    },
    getjackpot(tim, _false) {
      if (!this.$store.state.config.show_jackpot) return;
      // if(_false){return false}
      clearTimeout(this.thisiTime);
      this.thisiTime = setTimeout(() => {
        jackpot({
          isLOgin: true
        }).then(({ code, data, msg }) => {
          this.startVal = data - 1999 || 0;
          this.BonusAmount = data || 0;
        });
        if (this.$route.name == 'home') {
          this.getjackpot(10000);
        }
        let { code, category } = this.$route.query;
      }, tim);
    },
    onClickDisabled(e) {
      this.$router.push({
        name: 'subgame',
        query: {
          id: '',
          category: 'demo'
        }
      });
    },
    tabFun(e, title) {
      if (e == 7 && this.$store.state.config.group_info) {
        window.open(this.$store.state.config.group_info.jump, '_blank');
        return;
      }
      if (e < 4) {
        this.stateActive = true;
      } else {
        this.stateActive = false;
      }
      let category = this.iconList[e].name;
      if (category == 'recent') {
        this.congxJiazai(category, category);
        this[category + 'Json'] = {};
      }
      if (category == 'favorite') {
        this.congxJiazai(category, category);
        this[category + 'Json'] = {};
      }
      setTimeout(() => {
        this.$store.commit('active', e);
      }, 1000);
    },
    stickyScroLL(e) {}
  }
};
</script>
<style scoped>
.rawImg {
  width: 1rem;
  height: auto;
  margin-top: 0.3rem;
  margin-right: 0.12rem;
}
.live-box {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0.2rem 0.1rem 0;

  .live-box-item {
    width: 31%;

    img {
      width: 100%;
    }
  }
}

.swiper-box {
  padding: 0.1rem 0.2rem 0.2rem;
}

:deep(.van-grid-item__content) {
  background-color: transparent !important;
  padding: 0.2rem 0.1rem 0.05rem;
}

/* // isTabsShow van-sticky van-sticky--fixed */

.tabs .imageWrap {
  margin-left: -0.1rem;
}

.imageWrap_s {
  margin-left: 0.05rem;
}

.leftButton,
.rightButton {
  background-color: rgba(0, 0, 0, 0.1);
  border: 0.01rem solid hsla(0, 0%, 100%, 0.1);
  border-radius: 0.18rem;
  color: #fff;
  cursor: pointer;
  height: 0.36rem;
  line-height: 0.36rem;
  text-align: center;
  top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 0.36rem;
  min-width: 0.36rem;
}

.leftButton svg,
.rightButton svg {
  width: 0.15rem;
  height: 0.15rem;
}

.tabForm-box {
  width: 100%;
  height: 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 0.55rem;
  z-index: 10;
}

.h5MidMenuTab {
  padding: 0 0.092rem !important;
}

.leftButton {
  position: absolute;
  left: 0;
  transform: translateY(-50%) rotate(180deg);
}

.tabs .van-tabs__content {
  position: relative;
}

.rightButton {
  position: absolute;
  right: 0;
}
</style>
<style>
/* 	.maxMaxth3Dian1 .van-sticky.van-sticky--fixed {
		position: initial;
		transition: .5s;
	} */
.maxMaxth3Dian1 .van-tabs__wrap--scrollable .van-tab {
  padding: 0;
}

.maxMaxth3Dian1 .tabs .van-tabs .van-tabs__nav {
  background-color: transparent;
  border-bottom: 0.01rem solid var(--theme-color-line);
  height: 1.06rem;
  overflow: scroll;
  padding: 0.08rem 0 0;
  position: initial;
}

.isTabsShow .van-sticky {
  opacity: 0;
}

.van-sticky.van-sticky--fixed {
  transform: initial;
  transition: 0.5s;
}

.conter_box .van-tab--disabled {
  color: #646566 !important;
  cursor: pointer;
}

.conter_box .van-tab {
  padding: 0;
}

.home-scrollbar .van-tab__text--ellipsis {
  -webkit-line-clamp: initial;
}

.home-scrollbar .van-sticky--fixed {
  z-index: 88;
}

.home-scrollbar {
  height: 100vh;
  /* overflow: scroll; */
}

.conterTeng-scrollbar {
  overflow: scroll;
}

.conterTeng-scrollbar::-webkit-scrollbar {
  width: 0.06rem;
  height: 1rem;
  display: block;
  position: relative;
}

/* 自定义滚动条轨道 */
.conterTeng-scrollbar::-webkit-scrollbar-track {
  background: transparent;
  /* 设置轨道的背景颜色 */
}

/* 自定义滚动条的滑块（thumb） */
.conterTeng-scrollbar::-webkit-scrollbar-thumb {
  background: var(--theme-color-line);
  /* 设置滑块的背景颜色 */
}

/* 当滑块悬停或活动时自定义滚动条的滑块 */
.conterTeng-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #555;
  /* 设置滑块在悬停状态下的背景颜色 */
}

.conterTeng-scrollbar {
  -ms-overflow-style: scroll;
  /* 针对IE、Edge浏览器 */
  scrollbar-width: auto;
  /* 针对Firefox浏览器 */
}

.marquee {
  border-radius: 0;
  font-size: 0.24rem !important;
  padding: 0 0.2rem 0 0.25rem;
  -ms-flex-align: center;
  -ms-flex-pack: justify;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0) !important;
  color: var(--theme-text-color) !important;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0 !important;
}

.van-hairline--bottom::after {
  border: none !important;
}

.marquee .van-icon {
  display: flex;
  justify-content: center;
  align-content: center;
  margin-right: 5px;
}

.notice-bar {
  display: flex;
  width: 100%;
  align-items: center;
  box-sizing: border-box;
  padding: 0.06rem 0.2rem !important;
  cursor: pointer;
}

.zhtDEqmqr6aOwFvu_UTp {
  margin: 0 0.2rem;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  justify-content: center;
}

._VQdc8vOEOzzyOEUKmvZ {
  cursor: pointer;
  height: var(--jackpot-card-height);
  /* margin: var(--jackpot-card-margin); */
  position: relative;
  width: var(--jackpot-card-width);
  display: flex;
  align-items: center;
  justify-content: center;
}

.defaultValue {
  justify-content: center;
}

.tabs {
  height: 100%;
}

.vwuYKuCNAmUF0GsyJhVu {
  padding: 0 0.2rem;
}

.gameItemBox {
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  height: 100%;
}

.scroll-container {
  height: 100%;
  overflow: auto;
}

.tabs .van-tab {
  line-height: normal;
}

.tabs .van-tabs--line .van-tabs__wrap {
  height: auto !important;
}

.tabs .van-tabs .van-tabs__nav {
  background-color: var(--theme-home-bg);
  border-bottom: 0.01rem solid var(--theme-color-line);
  height: 1.06rem;
  padding: 0.08rem 0 0;
}

.tabs .van-tabs__line {
  background-color: var(--theme-primary-color);
  border-radius: 0.04rem 0.04rem 0 0;
  height: 0.04rem;
  min-width: 1.5rem;
  bottom: 0;
}

.maxMaxth3Dian1 .tabs .van-tab--active .h5MidMenuTab {
  color: var(--theme-alt-neutral-2) !important;
}

.maxMaxth3Dian1 .tabs .van-tabs__line {
  background-color: transparent !important;
}

.tabs .cover {
  background: transparent !important;
}

.tabs .imageWrap {
  height: 0.46rem !important;
  width: 0.6rem !important;
}

.h5MidMenuTab {
  min-width: 1.5rem;
  position: relative;
  text-align: center;
  z-index: 2;
  color: var(--theme-alt-neutral-2);
}

.game-category-name {
  line-height: 1.5;
  max-width: 1.36rem;
  width: 1.36rem !important;
}

.leftTitle {
  -ms-flex-align: center;
  align-items: center;
  color: var(--theme-text-color-darken);
  display: -ms-flexbox;
  display: flex;
  font-size: 0.3rem;
}

.rightTitle {
  margin: -0.12rem -0.2rem;
  padding: 0.12rem 0.2rem;
  color: var(--theme-text-color-lighten);
  cursor: pointer;
  font-size: 0.24rem;
}

.kQtvRRirB33JTKwlSb26 {
  -ms-flex-align: center;
  -ms-flex-pack: justify;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  padding: 0.3rem 0;
}

.bkAYznjEc9hUqGQh_a3S {
  display: block;
  font-size: 0.24rem;
  text-align: center;
  color: var(--theme-text-color-lighten);
  margin-top: 0.1rem;
  margin-bottom: 0.2rem;
}

.WGAruokZzpTWkHI2SQ9G {
  color: var(--theme-text-color);
  display: block;
  font-size: 0.24rem;
  margin-top: 0.03rem;
}

.LseXQWJMvDiV2XalL3sA {
  padding: 0.4rem 0.2rem;
  position: relative;
  width: 100%;
  background-color: var(--theme-btm-bg-color);
  z-index: 1;
  box-sizing: border-box;
}

.UJY0E549iXw8BAops2og {
  -ms-flex: 1;
  flex: 1;
  overflow: hidden;
}

.vertival-box {
  margin-bottom: 0;
  padding-bottom: 0;
  position: initial;
}

.vertival-box > div {
  padding-right: 0.2rem;
}

.UJY0E549iXw8BAops2og .JxE2bCrlce_jVHNQ56UL {
  color: var(--theme-text-color-lighten);
  font-size: 0.26rem;
  margin-bottom: 0.2rem;
}

.TxOZ1v6RrtK6SNKSEukb .vertival-box {
  margin-bottom: 0.4rem;
  padding-bottom: 0.48rem;
  position: relative;
}

.bUGFPYZ0IBtUg6TvqFnc {
  display: -ms-flexbox;
  display: flex;
}

.link-list-title {
  color: var(--theme-text-color);

  margin-bottom: 0.2rem;
}

.mmensnemConem {
  position: relative;
  padding-bottom: 0.4rem;
}

.mmensnemConem:after,
.vertival-box:after {
  background-color: var(--theme-color-line);
  bottom: 0;
  content: '';
  height: 0.01rem;
  left: 50%;
  position: absolute;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 100%;
}

.UJY0E549iXw8BAops2og .dIvaBEC9yHdlaEHxlYwe .m4LhLKEZzJw_JjBFp0PP {
  color: var(--theme-text-color);
  cursor: pointer;
  font-size: 0.24rem !important;
  margin-bottom: 0.2rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.company-info {
  font-size: 0.24rem;
  padding-bottom: 0;
  position: initial;
  text-align: unset;
}

.contactus-box {
  margin-bottom: 0.3rem;
}

.dX6cyFScnFIBaOgvBaOs {
  color: var(--theme-text-color-lighten);
  font-size: 0.26rem;
  font-weight: 400;
  margin-bottom: 0.2rem;
}

.ZRKW0CIFYaJACLzrm8Rh {
  box-sizing: border-box;
  height: 0.7rem;
  display: flex;
}

.license-compliance {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.M5NoRqtHOQuocfpNLEaP {
  -ms-flex-align: center;
  align-items: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  box-sizing: border-box;
  gap: 0.2rem;
}

.TNhhMltbvlGJmWgLd9F5 {
  -ms-flex-pack: center;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  gap: 0.1rem;
  justify-content: center;
  margin-top: 0.4rem;
}

.copy-right {
  padding-top: 0.4rem;
}

/* .ZvyDsn48oSuCoga63jmJ ul {
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    width: 100%
} */
.ZvyDsn48oSuCoga63jmJ {
  -ms-flex-pack: center;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  width: 100%;
}

.ZvyDsn48oSuCoga63jmJ ul {
  -ms-flex-pack: center;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  margin: 0 !important;
  width: 100%;
}

.ZvyDsn48oSuCoga63jmJ ul li {
  border-right: 0.01rem solid var(--theme-color-line);
  color: var(--theme-text-color-lighten);
  font-size: 0.16rem;
  line-height: 1.2;
  overflow: hidden;
  padding: 0 0.32rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ZvyDsn48oSuCoga63jmJ ul li:last-child {
  border-right: 0;
}

.svg-icon_pmd {
  position: absolute;
  left: 0;
}

.N4LsWhJBhqqyTkv6V0NE {
}

/* 精灵图字体样式 */
.sprite-font {
  display: inline-block;
  height: 0.83rem;
  vertical-align: top;
  background-repeat: no-repeat;
  background-size: auto 100%;
}

/* 数字字符样式 - 如果需要固定位置的话可以使用这些类 */
.sprite-char-0 {
  background-position: 0 0;
  width: 0.5rem;
}

.sprite-char-1 {
  background-position: -0.5rem 0;
  width: 0.5rem;
}

.sprite-char-2 {
  background-position: -1rem 0;
  width: 0.5rem;
}

.sprite-char-3 {
  background-position: -1.5rem 0;
  width: 0.5rem;
}

.sprite-char-4 {
  background-position: -2rem 0;
  width: 0.5rem;
}

.sprite-char-5 {
  background-position: -2.5rem 0;
  width: 0.5rem;
}

.sprite-char-6 {
  background-position: -3rem 0;
  width: 0.5rem;
}

.sprite-char-7 {
  background-position: -3.5rem 0;
  width: 0.5rem;
}

.sprite-char-8 {
  background-position: -4rem 0;
  width: 0.5rem;
}

.sprite-char-9 {
  background-position: -4.5rem 0;
  width: 0.5rem;
}

.sprite-char-dot,
.sprite-char-\. {
  background-position: -5rem 0;
  width: 0.3rem;
}

.sprite-char-comma,
.sprite-char-\, {
  background-position: -5.3rem 0;
  width: 0.3rem;
}

/* Sidebar滚动隐藏效果 */
.sidebar-hidden {
  transform: translateX(60%) !important;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out !important;
}

.sidebaLeft-hidden {
  transform: translateX(-60%) !important;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out !important;
}

/* 确保sidebars组件有过渡效果 */
sidebars {
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}

._marketing-title_1k0qx_129 {
  position: absolute;
  bottom: 0;
  left: 50%;
  max-width: 100%;
  transform: translate(-50%);
  box-shadow: inset 0 0 0 0.01rem rgba(255, 255, 255, 0.3);
  border-radius: 0.15rem;
  color: #fff;
  font-size: 0.2rem;
  padding: 0 0.1rem;
  height: 0.3rem;
  line-height: 0.3rem;
  z-index: 1;
  margin-bottom: 0.15rem;
}

/* 确保 van-grid-item 有相对定位，为绝对定位的标题提供定位上下文 */
:deep(.van-grid-item) {
  position: relative;
}
</style>
